<template>
    <UrbnModalLauncher
        :modalOptions="{
            ...pdpImageViewerZoomModal,
            title: productName,
            props: {
                title: productName,
                images: productImages,
                selectedImage: productIndex,
                pdpImageViewerZoomModalId: pdpImageViewerZoomModal.id,
                imagesFullWidth,
                choiceId,
            },
        }"
        class="c-image-viewer__link"
        type="link"
        @click="pushZoomHashRoute"
    >
        <div class="c-image-viewer__image-wrapper">
            <ProductImage
                :src="productImage"
                :title="`${productName} product image`"
                :choiceId="choiceId"
                :imagePreset="imagePreset"
                :isLazyImage="true"
                :shouldDisplayImage="true"
                :fadeInAfterLoaded="true"
                class="c-image-viewer__image"
            />
        </div>
    </UrbnModalLauncher>
</template>

<script>

import { GLOBAL_IMAGE_PRESETS } from '~coreModules/core/js/constants';
import { GLOBAL_MODALS } from '~coreModules/modals/js/modal-constants';

import ProductImage from '~coreModules/core/components/ui/ProductImage.vue';
import UrbnModalLauncher from '~coreModules/modals/components/UrbnModalLauncher.vue';

export default {
    name: 'ImageViewerImage',
    components: {
        ProductImage,
        UrbnModalLauncher,
    },
    props: {
        productName: {
            type: String,
            required: true,
        },
        productIndex: {
            type: Number,
            required: true,
        },
        productImage: {
            type: String,
            required: true,
        },
        productImages: {
            type: Array,
            required: true,
        },
        imagesFullWidth: {
            type: Boolean,
            default: true,
        },
        choiceId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            pdpImageViewerZoomModal: GLOBAL_MODALS.pdpImageViewerZoom,
            imagePreset: GLOBAL_IMAGE_PRESETS.product.regular,
        };
    },
    methods: {
        pushZoomHashRoute() {
            this.$router.push({
                hash: `#${this.pdpImageViewerZoomModal.id}`,
                path: this.$route.path,
                query: this.$route.query,
            });
        },
    },
};
</script>

<style lang="scss">
.c-image-viewer {
    &__image-wrapper {
        position: relative;
        width: 100%;
        overflow: hidden;

        &::before {
            position: relative;
            display: block;
            content: "";
            width: 100%;
            padding-top: 150%; /* 2:3 aspect ratio */
            background-color: $placeholder-background;
        }
    }

    &__link.focus-visible:focus[data-focus-visible-added] {
        outline: none;
    }

    &__image {
        position: absolute;
        top: 0;
        width: 100%;

        .focus-visible:focus[data-focus-visible-added] & {
            outline: $focus-outline;
            outline-offset: -4px;
            transition: unset;
        }
    }
}

</style>
